import styled from "styled-components";

export const StyledHomePage = styled.main`
	animation: slideLeft 0.4s ease forwards;
`;
